const isLocal = process.env.REACT_APP_ENV === 'local';

export const pushDataLayerEvent = (
  event: string,
  params: Record<string, unknown> = {}
): void => {
  try {
    const payload = {
      event,
      ...(isLocal ? { debug_mode: true } : {}),
      ...params,
    };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    // Log will be deleted after testing on dev.
    // eslint-disable-next-line no-console
    console.log('[dataLayer.push]', payload);
  } catch {}
};
